var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2096_35655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0402 17.4668H5.97177C5.606 17.4668 5.33838 17.8235 5.45481 18.1696C5.81255 19.2335 6.81945 20.0001 8.00597 20.0001C9.19249 20.0001 10.1994 19.2336 10.5571 18.1696C10.6735 17.8236 10.4058 17.4668 10.0402 17.4668Z",
    fill: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3456 2.53331H6.55836C6.30782 2.53331 6.12448 2.17658 6.20415 1.83048C6.44927 0.766501 7.13912 0 7.95203 0C8.76495 0 9.4547 0.766501 9.69982 1.83048C9.77948 2.17648 9.59624 2.53331 9.3456 2.53331Z",
    fill: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.27468e-07 15.6821V15.6816C-0.00020069 15.3617 0.132707 15.0567 0.366173 14.8492C0.970635 14.312 2.09999 12.7685 1.99461 8.7772C1.90942 5.54787 3.01166 3.65473 4.3334 2.54474C6.43721 0.777925 9.53969 0.776622 11.6463 2.54163C12.9697 3.65042 14.075 5.54266 13.9947 8.77199C13.8955 12.7641 15.0277 14.3065 15.6328 14.8428C15.8665 15.05 15.9998 15.3547 16 15.6744C16.0005 16.2801 15.5298 16.7715 14.9488 16.7717L1.05211 16.7776C0.471454 16.778 0.000502522 16.2875 2.27468e-07 15.6821Z",
    fill: "#6D6D6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2096_35655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon-bell.e6d7f04077324192a4ce608bfee6afa3.svg";
export { ForwardRef as ReactComponent };